import { render, staticRenderFns } from "./customTable.vue?vue&type=template&id=24c83305&scoped=true"
import script from "./customTable.vue?vue&type=script&lang=js"
export * from "./customTable.vue?vue&type=script&lang=js"
import style0 from "./customTable.vue?vue&type=style&index=0&id=24c83305&prod&lang=less&scoped=true"
import style1 from "./customTable.vue?vue&type=style&index=1&id=24c83305&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c83305",
  null
  
)

export default component.exports